// cretae a horizontal line
import React from "react";

const HorizontalLine = ({ size = 24 }) => {
  return (
    <hr
      style={{
        marginTop: size + "px",
        marginBottom: size + "px",
        borderTop: "1px solid var(--color-review-border)",
      }}
    ></hr>
  );
};

export default HorizontalLine;
